import React from 'react';
import  ForgotPasswordForm  from '../components/auth/ForgotPasswordForm';
import  Logo  from '../components/ui/Logo';

const ForgotPasswordPage: React.FC = () => {
  const handleResetPassword = async (email: string) => {
    // This will be implemented in the form component
    console.log('Reset password for:', email);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex justify-center">
          <Logo size="lg" />
        </div>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Mot de passe oublié ?
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Entrez votre adresse email pour réinitialiser votre mot de passe
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <ForgotPasswordForm onSubmit={handleResetPassword} />
          
          <div className="mt-6 text-center">
            <a
              href="/login"
              className="font-medium text-blue-600 hover:text-blue-500"
            >
              Retour à la connexion
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;